import { render, staticRenderFns } from "./DocRaccourcis.vue?vue&type=template&id=ba5de8d6&"
import script from "./DocRaccourcis.vue?vue&type=script&lang=js&"
export * from "./DocRaccourcis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports